<template>
<div>
<v-list dense v-if='record.referrers.length > 0' two-line >
  <v-list-tile
    v-for='referrer in record.referrers'
    :key='referrer.id' >

    <v-list-tile-action >
      <v-menu offset-y >
        <template slot="activator"  >
          <v-btn icon >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-tile
            @click='changeCurrent(referrer)' >
            <v-list-tile-title v-if='referrer.is_current_referrer' >
             Not curent referrer</v-list-tile-title>
            <v-list-tile-title v-else >
             Make curent referrer</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile
            @click='markedForDelete = referrer; showRemoveConfirmation = true' >
            <v-list-tile-title>{{ $t('buttons.remove') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-list-tile-action>

    <v-list-tile-content v-if='referrer.therapist' >
        <v-list-tile-title>
          {{ referrer.therapist.title }}
          {{ referrer.therapist.initials }}
          {{ referrer.therapist.first_name }}
          {{ referrer.therapist.last_name }}.
          <small>{{ referrer.therapist.reference_number}}</small>
        </v-list-tile-title>
        <v-list-tile-sub-title >
          {{ $t('added') }}: {{ dateformat(referrer.created_date) }}
        </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action >
      <v-icon v-if='referrer.is_current_referrer' >check</v-icon>
      <v-list-tile-action-text v-if='referrer.is_current_referrer' >{{ $t('current') }}</v-list-tile-action-text>
    </v-list-tile-action>

  </v-list-tile>
  <v-progress-linear v-if='loading' class='my-0' indeterminate height='3' ></v-progress-linear>
</v-list>
<v-btn @click='showReferralPicker=true' flat >
  <v-icon>add</v-icon>Add a referrer</v-btn>
<v-dialog width='300' v-model='showReferralPicker' >
  <v-toolbar dense >
    <v-btn @click='pickerTouch++' icon small >
      <v-icon small>home</v-icon>
    </v-btn>
    Choose a referrer
    <v-spacer></v-spacer>
    <v-btn @click='showReferralPicker=false' icon small >
      <v-icon>close</v-icon>
    </v-btn>
  </v-toolbar>
  <referral-picker
    @selected='addReferrer'
    @close='showReferralPicker=false'
    :touch='pickerTouch' >
  </referral-picker>
</v-dialog>

<v-dialog width='300' v-model='showRemoveConfirmation' >
  <v-card v-if='markedForDelete && markedForDelete.therapist'>
    <v-card-title class='subheading'  >
      {{ $t('dialogs.confirmremove.title') }}</v-card-title>
    <v-card-text class='subheading' >
      Remove
      <strong>{{markedForDelete.therapist.first_name}} {{markedForDelete.therapist.last_name}}</strong>
      as a referrer for this record.
      <v-alert type='info' :value='true' dismissible >
        <p>{{ $t('dialogs.confirmremove.notes.p1') }}</p>
        <p>{{ $t('dialogs.confirmremove.notes.p2') }}</p>
      </v-alert>

    </v-card-text>
    <v-card-actions>
      <v-btn
        @click='showRemoveConfirmation=false'
        flat >Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        @click=removeReferrer(markedForDelete.id)
        :loading='removeRequest.loading'
        color='error' >{{ $t('buttons.remove') }}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</div>
</template>

<script>
import ReferralPicker from '@/components/pickers/ReferralPicker'

export default {
  name: 'Referrers',
  components: {ReferralPicker},
  props: {
    record: { type: Object, required: true }
  },
  data () {
    return {
      pickerTouch: 0,
      showReferralPicker: false,
      showRemoveConfirmation: false,
      requests: {
        add: 'record-referrer-add-req',
        edit: 'record-referrer-edit-req',
        get: 'record-get-request',
        remove: 'record-referrer-remove-req'
      },
      markedForDelete: {}
    }
  },
  computed: {
    getRequest () {
      return this.$store.getters.getRequestById(this.requests.get, true)
    },
    addRequest () {
      return this.$store.getters.getRequestById(this.requests.add, true)
    },
    addRequestStatus () {
      return this.addRequest.status
    },
    removeRequest () {
      return this.$store.getters.getRequestById(this.requests.remove, true)
    },
    removeRequestStatus () {
      return this.removeRequest.status
    },
    editRequest () {
      return this.$store.getters.getRequestById(this.requests.edit, true)
    },
    editRequestStatus () {
      return this.editRequest.status
    },
    loading () {
      return this.addRequest.loading ||
        this.removeRequest.loading ||
        this.getRequest.loading ||
        this.editRequest.loading
    }
  },
  watch: {
    addRequestStatus () {
      if (this.addRequestStatus === 201) {
        this.$emit('reload')
      }
    },
    editRequestStatus () {
      if (this.editRequestStatus === 200) {
        this.$emit('reload')
      }
    },
    removeRequestStatus () {
      if (this.removeRequestStatus === 204) {
        this.$emit('reload')
        this.showRemoveConfirmation = false
      }
    },
    showReferralPicker () {
      if (this.showReferralPicker === true) {
        this.pickerTouch ++
      }
    }
  },
  methods: {
    addReferrer (therapist) {
      let data = {
        record: this.record.id,
        therapist: therapist.id,
        is_current_referrer: true
      }
      this.$medicalaidguru
        .resource('referrer')
        .id(this.requests.add)
        .create(data)
    },
    removeReferrer (referrerId) {
      this.$medicalaidguru
        .resource('referrer')
        .id(this.requests.remove)
        .delete(referrerId)
    },
    changeCurrent (referrer) {
      let data = {
        is_current_referrer: !referrer.is_current_referrer
      }
      this.$medicalaidguru
        .resource('referrer')
        .id(this.requests.edit)
        .save(referrer.id, data)
    }
  },
  i18n: {
    messages: {
      en: {
        added: 'Added',
        current: 'current',
        buttons: {
          remove: 'Remove'
        },
        dialogs: {
          confirmremove: {
            title: 'Confirm removal',
            notes: {
              p1: 'This will NOT delete the referrer from your database, only unlink it from this record.',
              p2: 'If you would like to keep a history of previous referrers for this record, rather choose: "Not current user"'
            }
          }
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Referrers.vue?14f18ad2